// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TracesReview-Sidebar-module--cls1--1iy8i","cls2":"TracesReview-Sidebar-module--cls2--IE2jx TracesReview-Sidebar-module--cls1--1iy8i"};